export default __webpack_public_path__ + "static/media/no-signal.bb051afe.svg";